var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.36531 1.92982L5.90615 2.89892C6.39424 3.77349 6.1983 4.92078 5.42958 5.68951C5.42958 5.68951 5.42958 5.68951 5.42957 5.68951C5.42946 5.68962 4.49723 6.62207 6.18775 8.31258C7.8776 10.0024 8.81 9.07156 8.81081 9.07075C8.81084 9.07073 8.81083 9.07074 8.81085 9.07071C9.57958 8.30202 10.7268 8.10609 11.6014 8.59417L12.5705 9.13501C13.8911 9.87203 14.0471 11.724 12.8863 12.8848C12.1888 13.5823 11.3343 14.1251 10.3897 14.1609C8.79963 14.2212 6.09922 13.8187 3.3904 11.1099C0.681591 8.40111 0.279163 5.70069 0.339444 4.11058C0.375253 3.16601 0.917987 2.31154 1.61549 1.61403C2.77628 0.453243 4.6283 0.609205 5.36531 1.92982Z",
    fill: "#5A5A5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.7412adb123bc4382b9c8090e71a32e4b.svg";
export { ForwardRef as ReactComponent };